const UserInfoColumn = ({ children }) => <div className="userInfoColumn">{children}</div>

export default UserInfoColumn
